import { render, staticRenderFns } from "./AwardHeaderSection.vue?vue&type=template&id=30f8b1b0&scoped=true"
import script from "./AwardHeaderSection.vue?vue&type=script&lang=ts"
export * from "./AwardHeaderSection.vue?vue&type=script&lang=ts"
import style0 from "./AwardHeaderSection.vue?vue&type=style&index=0&id=30f8b1b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f8b1b0",
  null
  
)

export default component.exports